import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { CLIENT_ONBOARDING_UNABLE_TO_VERIFY_ROUTE } from 'routes/index';

// Axios Instance
import axiosInstance from 'services/API/API';

// our Endpoints
import { getMethodfiToken } from 'shared/api-urls';

function useMutateGetMethodfiToken() {
	const navigate = useNavigate();

	return useMutation(
		async (userDetailsSentToMFI) => {
			const response = await axiosInstance.post(getMethodfiToken, {
				type: 'individual',
				individual: userDetailsSentToMFI
			});

			const userData = response.data.data;

			return userData;
		},
		{
			onError: () => {
				navigate(CLIENT_ONBOARDING_UNABLE_TO_VERIFY_ROUTE);
			}
		}
	);
}

export default useMutateGetMethodfiToken;
